/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AutocastTemplateOptions = core.serialization.object({
    namespace: core.serialization.string().optional(),
    sheetSlug: core.serialization.string(),
    fieldFilters: core.serialization.list(core.serialization.string()).optional(),
    options: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
});
